import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { projelerData } from '../data/projeler-data';
import { motion } from 'framer-motion';
import LinkComponent from '../components/LinkComponent';
import Lightbox from 'yet-another-react-lightbox';
import { fadeInUp, azxc, bzxc } from '../script/animationVariants';
import { useTranslation } from 'react-i18next';

const ProjelerInnerInner = () => {
  const { id1, id2 } = useParams();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Mevcut dili alıyoruz

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const category = projelerData.find(category => category.link === id1);
  if (!category) return <div>{t('categoryNotFound')}</div>;

  const categoryInner = category.categoryItem.find(item => item.link === id2);
  if (!categoryInner) return <div>{t('itemNotFound')}</div>;

  const images = categoryInner.img.map((item) => ({
    src: `/images/projeler/${id1}/${id2}/${item}.jpg`,
  }));

  return (
    <div className='flex flex-col'>
      <LinkComponent />

      <div className='grid grid-cols-14 bg-white'>
        <div className='col-start-2 col-span-11'>
          <motion.div
            variants={fadeInUp(0.2)}
            initial="initial"
            whileInView="animate"
            className='mb-10 font-extralight text-2xl'
          >
            {categoryInner.title[currentLanguage]}
          </motion.div>
        </div>
      </div>

      <div className='w-full bg-white grid grid-cols-14 customHScreen'>
        <motion.div
          initial="hidden"
          whileInView="visible"
          variants={azxc}
          className='col-start-2 col-span-11 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-2'
        >
          {categoryInner.img.map((item, index) => {
            const isHovered = hoveredIndex !== null && hoveredIndex !== index;
            return (
              <motion.div
                variants={bzxc}
                key={index}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => {
                  setOpen(true);
                  setCurrentIndex(index);
                }}
                className='w-full overflow-hidden aspect-square relative group cursor-pointer'
              >
                <img
                  src={`/images/projeler/${id1}/${id2}/${item}.jpg`}
                  className='h-full w-full object-cover'
                  alt={categoryInner.title[currentLanguage]}
                />
                <img 
                  src='/images/filigran-square.png' 
                  className='absolute top-0 left-0 w-full h-full object-cover pointer-events-none' 
                  alt=""
                />
                <div className={`absolute top-0 left-0 h-full w-full transition-opacity bg-black duration-300 ${isHovered ? 'opacity-60' : 'opacity-30'}`}></div>
                <div className='absolute top-0 left-0 flex items-center justify-center h-full w-full opacity-0 rotate-45 group-hover:rotate-0 group-hover:opacity-100 duration-300'>
                  <div className="h-7 w-7 flex justify-center items-center relative">
                    <div className="h-px absolute w-full bg-white"></div>
                    <div className="h-px absolute w-full bg-white rotate-90"></div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>


      <div className=''>
        <div className='grid grid-cols-14'>
          <div className='col-start-2 col-span-11 '>
            <div className='text-xs font-extralight mb-5 mt-20'>KULLANILAN SİTEMLER</div>
          </div>
        </div>

        <div className='grid grid-cols-14'>

          <div className='col-start-2 col-span-11 grid grid-cols-1 md:grid-cols-2 gap-3'>
            {categoryInner.systems && categoryInner.systems.length > 0 ? (
              categoryInner.systems.map((system, idx) => {
                let systemName = system;
                let systemLink = `/sistemler`;
                let parentName = null;
                let systemImg = '';
                try {
                  const allCats = require('../data/urunler-data').DATA;
                  const allSystems = allCats.flatMap(cat => cat.innerCategory || []).concat(
                    allCats.flatMap(cat => cat.innerCategory ? cat.innerCategory.flatMap(ic => ic.innerCategory || []) : [])
                  );
                  const found = allSystems.find(s => s.link === system);
                  if (found && found.name) {
                    systemName = found.name[currentLanguage] || found.name.tr || system;
                    // Sistemin ana kategorisini bul
                    const parentCat = allCats.find(cat => (cat.innerCategory || []).some(ic => ic.link === system));
                    if (parentCat) {
                      systemLink = `/sistemler/${parentCat.link}/${system}`;
                      parentName = parentCat.name ? (parentCat.name[currentLanguage] || parentCat.name.tr) : null;
                    }
                    // Sistem görselini bul
                    if (found.images && found.images.length > 0) {
                      systemImg = `/images/systems/${parentCat ? parentCat.link : ''}/${system}/1.png`;
                      console.log(parentCat.link)
                    }
                  }
                } catch (e) {}
                return (
                  <div key={idx}>
                    <Link to={systemLink}>
                      <div className="cursor-pointer mb-8 group relative">
                        <div className="relative">
                          <img
                            src={systemImg}
                            className="aspect-video transition-all duration-300 object-cover w-full"
                            alt={systemName}
                            onError={e => { e.target.onerror = null; e.target.src = '/images/delete.jpg'; }}
                          />
                          <img 
                            src='/images/filigran-rectangle.png' 
                            className='absolute top-0 left-0 w-full h-full object-cover pointer-events-none' 
                            alt=""
                          />
                          <div className='absolute top-0 left-0 bg-black z-10 h-full w-full opacity-0 group-hover:opacity-30 transition-all duration-300'></div>
                        </div>
                        <div className="w-full flex justify-between items-center font-light text-20 pt-4 pb-4 relative">
                          <div>
                          <h2>{systemName}</h2>
                          <h2 className='text-14'>({parentName})</h2>
                          </div>
                          <div className="h-7 w-7 flex justify-center items-center relative pr-6">
                            <div className="h-px absolute w-full bg-customGray"></div>
                            <div className="h-px absolute w-full bg-customGray rotate-90"></div>
                          </div>
                          <div className="h-px w-1/3 bg-customGray absolute bottom-0 left-0"></div>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })
            ) : (
              <div>
                {/* <div>{t('Sistem bulunamadı') || 'Sistem bulunamadı'}</div> */}
              </div>
            )}

          </div>
        </div>
      </div>


      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={images.map(img => ({
          ...img,
          alt: ""
        }))}
        index={currentIndex}
        styles={{
          container: { backgroundColor: "rgba(0, 0, 0, .9)" },
        }}
        render={{
          slide: ({ slide }) => (
            <div className="relative w-full h-full flex items-center justify-center" style={{ padding: '40px 0' }}>
              <div className="relative inline-block" style={{ maxWidth: '100vw', maxHeight: 'calc(100vh - 80px)' }}>
                <img 
                  src={slide.src} 
                  alt={slide.alt || ""} 
                  className="block"
                  style={{ maxWidth: '100vw', maxHeight: 'calc(100vh - 80px)', width: 'auto', height: 'auto' }}
                />
                <img 
                  src="/images/filigran-square.png" 
                  alt="" 
                  className="absolute top-0 left-0 w-full h-full pointer-events-none"
                  style={{ objectFit: 'contain' }}
                />
              </div>
            </div>
          )
        }}
      />
    </div>
  );
};

export default ProjelerInnerInner;
